const getFormDataPayload = (formData) => {
  //get personalise name label
  var nameInput = document.getElementById("personalisation-name");

  if (nameInput && !nameInput.checkValidity()) {
    nameInput.reportValidity();
    return;
  }

  const nameValue = nameInput
    ? document.querySelector("#personalisation-name").value
    : null;
  const variantId = document.querySelector("#personalisation-id");
  const forValue = nameInput
    ? document.querySelector("#personalisation-for").value
    : null;
  const isBundle = !forValue;
  const personaliseNameItem =
    nameValue && forValue
      ? {
          id: variantId.value,
          quantity: 1,
          properties: {
            Name: nameValue,
          },
        }
      : null;

  const payload = {
    items: [
      personaliseNameItem,
      isBundle && nameValue
        ? {
            ...Object.fromEntries(formData),
            properties: {
              Name: nameValue,
            },
          }
        : Object.fromEntries(formData),
    ],
  };

  return JSON.stringify(payload);
};

const addToCartWithJson = (data, subBtn) => {
  if (subBtn) {
    subBtn.classList.add("is-loading");
    subBtn.setAttribute("disabled", true);
  }

  fetch(theme.routes.cart_add_url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: data,
  })
    .then((response) => response.json())
    .then((response) => {
      subBtn.disabled = false;
      subBtn.classList.remove("is-loading");

      if (response.status) {
        window.cart.addToCartError(response);
        window.cart.removeLoadingClass();
        window.cart.scrollToCartTop();
        return;
      }

      // window.cart.hideAddToCartErrorMessage();

      if (window.cart.cartDrawerEnabled) {
        window.cart.getCart();
      } else {
        window.location = theme.routes.cart_url;
      }
    })
    .catch((error) => console.log(error));
};

const initPersonalisation = () => {
  var nameInput = document.getElementById("personalisation-name");
  const addToCartBtn = document.querySelector(".product__submit__add");
  if (nameInput) {
    addToCartBtn.removeAttribute("data-add-to-cart");
    addToCartBtn.addEventListener("click", function (e) {
      e.preventDefault();
      const formData = new FormData(document.querySelector(".product__form"));
      const payload = getFormDataPayload(formData);
      console.log(payload);
      if (payload) {
        addToCartWithJson(payload, addToCartBtn);
      }
    });
  }
};

initPersonalisation();

const updateCartNote = () => {
  const cartNote = document.querySelector("#note");
  if (!cartNote) return;
  let note = "";
  window.cart.items.forEach((item) => {
    const title = item.dataset.itemTitle;
    const property = item.querySelector(
      ".cart__item__property span:last-child"
    );
    if (!property) return;
    const name = property.innerText;

    console.log(title, name);
    if (
      title.includes("Custom Side Labels") ||
      title.includes("Kit")
    ) {
      if (title.includes("Harness: XS") || title.includes("/ XS") ) {
        note += "XS";
      } else if (title.includes("Harness: S") || title.includes("/ S")) {
        note += "S";
      } else {
        note += "ML";
      }
    }
    note += ` | ${name}\n`;
  });
  cartNote.value = note;
};
window.addEventListener("theme:cart:update", updateCartNote);
window.addEventListener("theme:cart:open", () => {
  document.querySelector("#cart-drawer button[type=submit]").addEventListener('click', updateCartNote)
  document.querySelector('[data-item-remove]').addEventListener('click',  () => {
  setTimeout(() => {
    updateCartNote();
  }, 1000);
} )
  setTimeout(() => {
    updateCartNote();
  }, 1000);
});

const filterProductImgaeByVariant = () => {
  if (!window.product) return;
  const flkty = product.flkty;
  const flktyNav = product.flktyNav;
  if (flkty && flktyNav) {
    flkty.options.cellSelector = ".flickity-enabled .flickity";
    flktyNav.options.cellSelector = ".flickity-enabled .flickity";
    flkty.options.pageDots = true;
    flkty.element.style.marginBottom = "50px";
  }
  const wrapper = document.querySelector(".product-single__wrapper");
  const slides = wrapper.querySelectorAll(".product-single__media-slide");
  const thumbnails = wrapper.querySelectorAll(".product-single__thumbnail");

  const filterImages = (slides) => {
    slides.forEach((slide, i) => {
      // const lightBox = slide.querySelector('[rel="lightbox"]')
      const alt = slide.querySelector("img").alt;
      const inputColor =
        wrapper.querySelectorAll('input[name="options[Color]"]').length > 1
          ? wrapper.querySelector('input[name="options[Color]"]:checked')
          : wrapper.querySelector('input[name="options[Color]"]');
      const currentColor = inputColor? inputColor.value : '';
      const inputSize =
        wrapper.querySelectorAll('input[name="options[Dog Size]"]').length > 1
          ? wrapper.querySelector('input[name="options[Dog Size]"]:checked')
          : wrapper.querySelector('input[name="options[Dog Size]"]');
      const currentSize =  inputSize? inputSize.value : '';
      slide.style.display = "none";
      slide.classList.remove("flickity");
      // lightBox.removeAttribute("data-zoom-wrapper")
      if (currentColor == alt || currentSize == alt) {
        slide.style.display = "block";
        slide.classList.add("flickity");
        // lightBox.setAttribute("data-zoom-wrapper", '')
      }
    });
  };
  product.destroyProductSlider();
  filterImages(slides);
  filterImages(thumbnails);
  if (flkty && flktyNav) {
    product.initProductSlider();
    flkty.element.querySelector(".flickity-page-dots").style.visibility =
      "visible";
  }
};
window.addEventListener("theme:variant:change", filterProductImgaeByVariant);
window.addEventListener("load", filterProductImgaeByVariant);
